<div class="content-info container-fluid">
  <h2 class="mb-4 text-primary">📊 Exportable Reports Dashboard</h2>
  <hr class="my-3" />

  <div *ngIf="isClinicClient">
    <h4 class="mt-4 mb-3 text-success">
      <span class="badge bg-success">Inventory & Tax</span>
    </h4>
    <div class="list-group shadow-sm mb-5">
      <div class="list-group-item d-flex justify-content-between align-items-center">
        <div>
          <h6 class="mb-0 fw-bold">Inventory Stock Ledger Report</h6>
          <p class="text-muted small mb-0">
            Stock movement ledger by time period.
          </p>
        </div>
        <button class="btn btn-sm btn-outline-success ms-3 flex-shrink-0" (click)="openReportModal('stock')">
          Export
        </button>
      </div>
      <div class="list-group-item d-flex justify-content-between align-items-center">
        <div>
          <h6 class="mb-0 fw-bold">Purchase Tax Report</h6>
          <p class="text-muted small mb-0">
            Purchase and tax details by date range.
          </p>
        </div>
        <button class="btn btn-sm btn-outline-success ms-3 flex-shrink-0" (click)="openReportModal('purchase')">
          Export
        </button>
      </div>
    </div>
  </div>

  <hr *ngIf="isClinicClient && isRetailUser" class="my-4" />

  <div *ngIf="isRetailUser" class="row g-4">
    <div class="col-12">
      <h5 class="text-secondary mb-2">
        <span class="badge bg-secondary me-2">PO</span> Purchase Orders
      </h5>
      <p class="text-muted small">
        Reports related to Purchase Orders and items.
      </p>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PO-wise Summary Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Summarized Purchase Order data (value, status) by date range.
            </p>
            <button class="btn btn-sm btn-outline-primary align-self-start" (click)="openReportModal('poWiseSummary')">
              Export Summary
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PO Item-wise Detail Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Detailed line-item data for all Purchase Orders.
            </p>
            <button class="btn btn-sm btn-outline-primary align-self-start" (click)="openReportModal('poItemwise')">
              Export Details
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <h5 class="text-success mb-2">
        <span class="badge bg-success">GRN</span> Goods Received Notes
      </h5>
      <p class="text-muted small">GRN summaries and detailed receipts.</p>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">GRN-wise Summary Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Summarized GRN data by date range.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start" (click)="openReportModal('grnWiseSummary')">
              Export GRN
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">GRN Item-wise Detail Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Line-item details for received goods.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start" (click)="openReportModal('grnItemwise')">
              Export Items
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Supplier Purchase Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Purchase totals, discounts and taxes grouped by supplier.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start"
              (click)="openReportModal('supplierPurchaseSummary')">
              Export Summary
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Cancelled GRN Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              GRNs cancelled in the period, with supplier and invoice details.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start"
              (click)="openReportModal('cancelledGrnSummary')">
              Export Cancelled
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">GIN Item-wise Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Line-item detail of GINs raised from the device, with entered and
              free quantity per line.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start"
              (click)="openReportModal('ginItemwise')">
              Export Items
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Month-wise Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Purchases rolled up by month, item and supplier.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start"
              (click)="openReportModal('monthWiseSummary')">
              Export Summary
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">GIN vs GRN</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Stock-take scans compared with quantity received on GRNs.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start"
              (click)="openReportModal('ginVsGrn')">
              Export Comparison
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <h5 class="text-info mb-2">
        <span class="badge bg-info text-dark me-2">Transfer</span> Transfers
      </h5>
      <p class="text-muted small">Incoming and outgoing inventory transfers.</p>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Transfer-In Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Summarized incoming transfers by date range.
            </p>
            <button class="btn btn-sm btn-outline-info text-dark align-self-start"
              (click)="openReportModal('transferInSummary')">
              Export
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Transfer-In Item-wise</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Detailed line-items for incoming transfers.
            </p>
            <button class="btn btn-sm btn-outline-info text-dark align-self-start"
              (click)="openReportModal('transferInItemwise')">
              Export
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Transfer-Out Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Outgoing inventory transfers summary.
            </p>
            <button class="btn btn-sm btn-outline-info text-dark align-self-start"
              (click)="openReportModal('transferOutSummary')">
              Export
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Transfer-out Item-wise Summary Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Detailed line-item data for all outgoing inventory transfers.
            </p>
            <button class="btn btn-sm btn-outline-info text-dark align-self-start"
              (click)="openReportModal('transferOutItemwise')">
              Export
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Combined TO / TI Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Summary of both incoming and outgoing transfers in a single report.
            </p>
            <button class="btn btn-sm btn-outline-info text-dark align-self-start"
              (click)="openReportModal('transferToTiSummary')">
              Export
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <h5 class="text-warning mb-2">
        <span class="badge bg-warning text-dark me-2">Comparison</span> PO vs GRN Fill Rates
      </h5>
      <p class="text-muted small">Compare Purchase Orders against received Goods Notes.</p>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PO vs GRN SKU-wise Fill</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              SKU-level comparison of ordered vs received quantities.
            </p>
            <button class="btn btn-sm btn-outline-warning text-dark align-self-start"
              (click)="openReportModal('poVsGrnSkuFill')">
              Export Report
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PO vs GRN Vendor-wise Fill</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Analyze vendor performance and fulfillment rates.
            </p>
            <button class="btn btn-sm btn-outline-warning text-dark align-self-start"
              (click)="openReportModal('poVsGrnVendorFill')">
              Export Report
            </button>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PO vs GRN Amount-wise Fill</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Compare financial values of POs vs realized GRNs.
            </p>
            <button class="btn btn-sm btn-outline-warning text-dark align-self-start"
              (click)="openReportModal('poVsGrnAmountFill')">
              Export Report
            </button>
          </div>
        </div> -->
      </div>
    </div>

    <div class="col-12 mt-4">
      <h5 class="text-primary mb-2">
        <span class="badge bg-primary me-2">PRN / Sales</span> Returns & Sales
      </h5>
      <p class="text-muted small">PRN reports and sales reporting.</p>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PRN Summary Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Returns and PRN level summary.
            </p>
            <button class="btn btn-sm btn-outline-danger align-self-start" (click)="openReportModal('prnSummary')">
              Export PRN
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">PRN Item-wise Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Item-level return details.
            </p>
            <button class="btn btn-sm btn-outline-danger align-self-start" (click)="openReportModal('prnItemwise')">
              Export
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Sales Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              High level sales by period.
            </p>
            <button class="btn btn-sm btn-outline-success align-self-start" (click)="openReportModal('salesSummary')">
              Export Sales
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Sales-detail Summary</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Line-item sales details for reconciliation.
            </p>
            <button class="btn btn-sm btn-outline-primary align-self-start" (click)="openReportModal('salesDetails')">
              Export
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <h5 class="text-dark mb-2">
        <span class="badge bg-dark me-2">Shrinkage</span> Shrinkage Reports
      </h5>
      <p class="text-muted small">
        Monitor inventory shrinkage and stock take discrepancies.
      </p>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">MBQ Shrinkage Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Inventory shrinkage and discrepancy reports.
            </p>
            <button class="btn btn-sm btn-outline-dark align-self-start" (click)="openReportModal('mbqShrinkage')">
              Export
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="p-3 border rounded h-100 d-flex flex-column">
            <h6 class="mb-1 fw-bold">Stock Take Shrinkage Report</h6>
            <p class="text-muted small mb-3 flex-grow-1">
              Final physical sign-off workbook for a completed stock take:
              sign-off summary, dept summary, type summary, contra, top 100
              excess / short, Phy Main, MAIN, upload and scan data.
            </p>
            <button class="btn btn-sm btn-outline-dark align-self-start" (click)="openStockTakeShrinkageModal()">
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stock Take Shrinkage: keyed to a completed stock take rather than a
       date range, so it gets its own small modal. -->
  <div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showShrinkageModal }"
    [style.display]="showShrinkageModal ? 'block' : 'none'">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-white shadow-sm border-bottom-0">
          <h5 class="modal-title text-primary">Export Stock Take Shrinkage Report</h5>
          <button type="button" class="btn-close" (click)="closeShrinkageModal()" aria-label="Close"></button>
        </div>

        <div class="modal-body bg-light p-4">
          <div class="card shadow-sm mb-3">
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label fw-bold text-dark small mb-1">Store / Warehouse</label>
                  <select class="form-select" [(ngModel)]="shrinkStoreId" name="shrinkStoreId"
                    (ngModelChange)="onShrinkStoreChange()" [disabled]="isLoadingFilters">
                    <option value="">-- Select location --</option>
                    <option *ngFor="let loc of productFilters.storeLocations" [value]="loc.id">
                      {{ loc.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold text-dark small mb-1">Completed Stock Take</label>
                  <select class="form-select" [(ngModel)]="shrinkSelected" name="shrinkSelected"
                    (ngModelChange)="onShrinkStockTakeChange()"
                    [disabled]="!shrinkStoreId || shrinkLoadingList">
                    <option value="">
                      {{ shrinkLoadingList ? 'Loading...' : (shrinkStoreId && shrinkStockTakes.length === 0 ? 'No completed stock takes' : '-- Select stock take --') }}
                    </option>
                    <option *ngFor="let st of shrinkStockTakes" [value]="shrinkKey(st)">
                      {{ shrinkLabel(st) }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12">
                  <label class="form-label fw-bold text-dark small mb-1">Previous Stock Take (shrinkage window starts here)</label>
                  <select class="form-select" [(ngModel)]="shrinkPrevSelected" name="shrinkPrevSelected"
                    [disabled]="!shrinkSelected">
                    <option value="auto">Auto - latest completed stock take before the selected one</option>
                    <option *ngFor="let st of shrinkPrevOptions" [value]="shrinkKey(st)">
                      {{ shrinkLabel(st) }}
                    </option>
                  </select>
                  <small class="text-muted">
                    Movements (GRN, PRN, sales, transfers, write-offs, repack) between the two stock takes make up
                    Total Purchase / Total Sales and the previous-shrinkage block.
                  </small>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold text-dark small mb-1">Name of the Auditor(s)</label>
                  <input type="text" class="form-control" [(ngModel)]="shrinkAuditor" name="shrinkAuditor"
                    maxlength="120" placeholder="Printed on the sign-off sheet" />
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold text-dark small mb-1">Name of the WH / Store Manager</label>
                  <input type="text" class="form-control" [(ngModel)]="shrinkManager" name="shrinkManager"
                    maxlength="120" placeholder="Printed on the sign-off sheet" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer bg-white border-top shadow-sm">
          <div *ngIf="isLoading" class="w-100 mb-2">
            <div class="progress" style="height: 6px">
              <div class="progress-bar"
                [class.progress-bar-striped]="downloadProgress === 0"
                [class.progress-bar-animated]="downloadProgress === 0"
                role="progressbar"
                [style.width.%]="downloadProgress > 0 ? downloadProgress : 100">
              </div>
            </div>
            <small class="text-muted">
              {{ downloadLabel }}
              <span *ngIf="downloadedBytes > 0">
                &middot; {{ formatBytes(downloadedBytes) }}</span>
            </small>
          </div>
          <button class="btn btn-secondary" (click)="closeShrinkageModal()">Cancel</button>
          <button class="btn btn-success" (click)="downloadShrinkageReport()"
            [disabled]="isLoading || !shrinkSelected">
            <i *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></i>
            {{ downloadLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="reportModals"></ng-container>

  <ng-template #reportModals>
    <div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showReportModal }"
      [style.display]="showReportModal ? 'block' : 'none'" *ngIf="this.isRetailUser">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-white shadow-sm border-bottom-0">
            <h5 class="modal-title text-primary">
              Export {{ currentReportTitle }} Report
            </h5>
            <button type="button" class="btn-close" (click)="closeReportModal()" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-light p-4">
            <div class="card shadow-sm mb-4">
              <div class="card-body">
                <h6 class="fw-bold mb-3">Select Date Range</h6>

                <div class="mb-3">
                  <label class="form-label fw-bold text-dark small mb-2">Quick Select:</label>
                  <div class="d-flex flex-wrap gap-2">
                    <button type="button" class="btn btn-sm" [ngClass]="
                        selectedPreset === 'today'
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      " (click)="setRelative('today')">
                      Today
                    </button>
                    <button type="button" class="btn btn-sm" [ngClass]="
                        selectedPreset === 'yesterday'
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      " (click)="setRelative('yesterday')">
                      Yesterday
                    </button>
                    <button type="button" class="btn btn-sm" [ngClass]="
                        selectedPreset === 'weekToDate'
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      " (click)="setRelative('weekToDate')">
                      WTD
                    </button>
                    <button type="button" class="btn btn-sm" [ngClass]="
                        selectedPreset === 'monthToDate'
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      " (click)="setRelative('monthToDate')">
                      MTD
                    </button>
                    <button type="button" class="btn btn-sm" [ngClass]="
                        selectedPreset === 'yearToDate'
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      " (click)="setRelative('yearToDate')">
                      YTD
                    </button>
                    <button type="button" class="btn btn-sm" [ngClass]="
                        selectedPreset === 'previousMonth'
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      " (click)="setRelative('previousMonth')">
                      Prev. Month
                    </button>
                  </div>
                </div>

                <div class="row g-3 mt-2">
                  <div class="col-md-6">
                    <input type="date" class="form-control" [(ngModel)]="fromDate" name="fromDate"
                      (ngModelChange)="selectedPreset = null" placeholder="dd/mm/yyyy" required />
                  </div>
                  <div class="col-md-6">
                    <input type="date" class="form-control" [(ngModel)]="toDate" name="toDate"
                      (ngModelChange)="selectedPreset = null" placeholder="dd/mm/yyyy" required />
                  </div>
                </div>
              </div>
            </div>

            <h6 class="fw-bold text-primary mb-3">
              <i class="bi bi-filter me-2"></i> Product Filters (Optional)
            </h6>

            <div *ngIf="isLoadingFilters" class="text-center p-5 bg-white rounded shadow-sm">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 text-muted">Loading filter options...</p>
            </div>

            <div class="row g-4" *ngIf="!isLoadingFilters">
              <div class="col-md-4">
                <div class="card card-body h-100 shadow-sm border">
                  <h6 class="fw-bold mb-2 text-dark">Select all Locations</h6>
                  <input type="text" [(ngModel)]="locationSearchTerm" placeholder="Search locations..."
                    class="form-control form-control-sm mb-2" />
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" [checked]="allLocationsSelected"
                      (change)="toggleSelectAllLocations()" id="selectAllLocations" />
                    <label class="form-check-label fw-bold small" for="selectAllLocations">Select All Locations</label>
                  </div>
                  <div class="list-group list-group-flush border" style="max-height: 200px; overflow-y: auto">
                    <div class="list-group-item py-1 px-3" *ngFor="let loc of filteredLocations">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [checked]="isLocationSelected(loc.id)"
                          (change)="toggleLocation(loc.id)" [id]="'loc_' + loc.id" />
                        <label class="form-check-label small" [for]="'loc_' + loc.id">{{ loc.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card card-body h-100 shadow-sm border">
                  <h6 class="fw-bold mb-2 text-dark">Select all Vendors</h6>
                  <input type="text" [(ngModel)]="vendorSearchTerm" placeholder="Search vendors..."
                    class="form-control form-control-sm mb-2" />
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" [checked]="allVendorsSelected"
                      (change)="toggleSelectAllVendors()" id="selectAllVendors" />
                    <label class="form-check-label fw-bold small" for="selectAllVendors">Select All Vendors</label>
                  </div>
                  <div class="list-group list-group-flush border" style="max-height: 200px; overflow-y: auto">
                    <div class="list-group-item py-1 px-3" *ngFor="let vendor of filteredVendors">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [checked]="isVendorSelected(vendor.id)"
                          (change)="toggleVendor(vendor.id)" [id]="'vendor_' + vendor.id" />
                        <label class="form-check-label small" [for]="'vendor_' + vendor.id">{{ vendor.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card card-body h-100 shadow-sm border">
                  <h6 class="fw-bold mb-2 text-dark">
                    Select all Manufacturers
                  </h6>
                  <input type="text" [(ngModel)]="manufacturerSearchTerm" placeholder="Search manufacturers..."
                    class="form-control form-control-sm mb-2" />
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" [checked]="allManufacturersSelected"
                      (change)="toggleSelectAllManufacturers()" id="selectAllManufacturers" />
                    <label class="form-check-label fw-bold small" for="selectAllManufacturers">Select All
                      Manufacturers</label>
                  </div>
                  <div class="list-group list-group-flush border" style="max-height: 200px; overflow-y: auto">
                    <div class="list-group-item py-1 px-3" *ngFor="let mfr of filteredManufacturers">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [checked]="isManufacturerSelected(mfr.id)"
                          (change)="toggleManufacturer(mfr.id)" [id]="'mfr_' + mfr.id" />
                        <label class="form-check-label small" [for]="'mfr_' + mfr.id">{{ mfr.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card card-body h-100 shadow-sm border">
                  <h6 class="fw-bold mb-2 text-dark">Select all Brands</h6>
                  <input type="text" [(ngModel)]="brandSearchTerm" placeholder="Search brands..."
                    class="form-control form-control-sm mb-2" />
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" [checked]="allBrandsSelected"
                      (change)="toggleSelectAllBrands()" id="selectAllBrands" />
                    <label class="form-check-label fw-bold small" for="selectAllBrands">Select All Brands</label>
                  </div>
                  <div class="list-group list-group-flush border" style="max-height: 200px; overflow-y: auto">
                    <div class="list-group-item py-1 px-3" *ngFor="let brand of filteredBrands">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [checked]="isBrandSelected(brand.id)"
                          (change)="toggleBrand(brand.id)" [id]="'brand_' + brand.id" />
                        <label class="form-check-label small" [for]="'brand_' + brand.id">{{ brand.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card card-body h-100 shadow-sm border">
                  <h6 class="fw-bold mb-2 text-dark">Select all Categories</h6>
                  <input type="text" [(ngModel)]="categorySearchTerm" placeholder="Search categories..."
                    class="form-control form-control-sm mb-2" />
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" [checked]="allCategoriesSelected"
                      (change)="toggleSelectAllCategories()" id="selectAllCategories" />
                    <label class="form-check-label fw-bold small" for="selectAllCategories">Select All
                      Categories</label>
                  </div>
                  <div class="list-group list-group-flush border" style="max-height: 200px; overflow-y: auto">
                    <div class="list-group-item py-1 px-3" *ngFor="let cat of filteredCategories">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [checked]="isCategorySelected(cat.id)"
                          (change)="toggleCategory(cat.id)" [id]="'cat_' + cat.id" />
                        <label class="form-check-label small" [for]="'cat_' + cat.id">{{ cat.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card card-body h-100 shadow-sm border">
                  <h6 class="fw-bold mb-2 text-dark">
                    Select all Sub Categories
                  </h6>
                  <input type="text" [(ngModel)]="subCategorySearchTerm" placeholder="Search sub categories..."
                    class="form-control form-control-sm mb-2" />
                  <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" [checked]="allSubCategoriesSelected"
                      (change)="toggleSelectAllSubCategories()" id="selectAllSubCategories" />
                    <label class="form-check-label fw-bold small" for="selectAllSubCategories">Select All Sub
                      Categories</label>
                  </div>
                  <div class="list-group list-group-flush border" style="max-height: 200px; overflow-y: auto">
                    <div class="list-group-item py-1 px-3" *ngFor="let subcat of filteredSubCategories">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" [checked]="isSubCategorySelected(subcat.id)"
                          (change)="toggleSubCategory(subcat.id)" [id]="'subcat_' + subcat.id" />
                        <label class="form-check-label small" [for]="'subcat_' + subcat.id">{{ subcat.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4 p-2 bg-white rounded shadow-sm border" *ngIf="
                selectedStoreLocations.length > 0 ||
                selectedVendors.length > 0 ||
                selectedManufacturers.length > 0 ||
                selectedBrands.length > 0 ||
                selectedCategories.length > 0 ||
                selectedSubCategories.length > 0
              ">
              <small class="text-muted">
                <i class="bi bi-info-circle me-1 text-primary"></i>
                <strong>Active Filters:</strong>
                <span *ngIf="selectedStoreLocations.length > 0" class="badge bg-primary me-1">{{
                  selectedStoreLocations.length }} Location(s)</span>
                <span *ngIf="selectedVendors.length > 0" class="badge bg-primary me-1">{{ selectedVendors.length }}
                  Vendor(s)</span>
                <span *ngIf="selectedManufacturers.length > 0" class="badge bg-primary me-1">{{
                  selectedManufacturers.length }} Manufacturer(s)</span>
                <span *ngIf="selectedBrands.length > 0" class="badge bg-primary me-1">{{ selectedBrands.length }}
                  Brand(s)</span>
                <span *ngIf="selectedCategories.length > 0" class="badge bg-primary me-1">{{ selectedCategories.length
                  }} Category(s)</span>
                <span *ngIf="selectedSubCategories.length > 0" class="badge bg-primary me-1">{{
                  selectedSubCategories.length }} Sub Category(s)</span>
              </small>
            </div>
          </div>

          <div class="modal-footer bg-white border-top shadow-sm">
            <!-- Progress feedback: large exports spend most of their time on
                 the server with no bytes flowing, so an indeterminate bar is
                 shown until a real percentage is available. -->
            <div *ngIf="isLoading" class="w-100 mb-2">
              <div class="progress" style="height: 6px">
                <div class="progress-bar"
                  [class.progress-bar-striped]="downloadProgress === 0"
                  [class.progress-bar-animated]="downloadProgress === 0"
                  role="progressbar"
                  [style.width.%]="downloadProgress > 0 ? downloadProgress : 100">
                </div>
              </div>
              <small class="text-muted">
                {{ downloadLabel }}
                <span *ngIf="downloadedBytes > 0">
                  &middot; {{ formatBytes(downloadedBytes) }}</span>
              </small>
            </div>
            <button class="btn btn-secondary" (click)="closeReportModal()">
              Cancel
            </button>
            <button class="btn btn-primary" (click)="downloadReport()" [disabled]="isLoading || !hasValidSelection">
              <i *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></i>
              {{ downloadLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showReportModal }"
      [style.display]="showReportModal ? 'block' : 'none'" *ngIf="this.isClinicClient">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-light">
            <h5 class="modal-title">Export {{ currentReportTitle }} Report</h5>
            <button type="button" class="btn-close" (click)="closeReportModal()" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div *ngIf="currentReportType === 'stock'" class="mb-4 p-3 border rounded bg-white shadow-sm">
              <div class="mb-3">
                <label class="form-label fw-bold text-dark small mb-2">Quick Select Presets (Period Type):</label>
                <div class="d-flex flex-wrap gap-2">
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedStockPreset === 'Daily'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setStockPreset('Daily')">
                    Daily
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedStockPreset === 'Monthly'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setStockPreset('Monthly')">
                    Monthly
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedStockPreset === 'Yearly'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setStockPreset('Yearly')">
                    Yearly
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="currentReportType !== 'stock'" class="mb-4 p-3 border rounded bg-white shadow-sm">
              <div class="mb-3">
                <label class="form-label fw-bold text-dark small mb-2">Quick Select Presets:</label>
                <div class="d-flex flex-wrap gap-2">
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedPreset === 'today'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setRelative('today')">
                    Today
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedPreset === 'yesterday'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setRelative('yesterday')">
                    Yesterday
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedPreset === 'weekToDate'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setRelative('weekToDate')">
                    WTD
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedPreset === 'monthToDate'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setRelative('monthToDate')">
                    MTD
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedPreset === 'yearToDate'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setRelative('yearToDate')">
                    YTD
                  </button>
                  <button type="button" class="btn btn-sm" [ngClass]="
                      selectedPreset === 'previousMonth'
                        ? 'btn-primary'
                        : 'btn-outline-secondary'
                    " (click)="setRelative('previousMonth')">
                    Prev. Month
                  </button>
                </div>
              </div>
            </div>

            <div class="mt-3 p-3 border rounded bg-white shadow-sm">
              <label class="form-label fw-bold text-dark small mb-2">Or select a custom range:</label>
              <div class="d-flex align-items-center gap-2">
                <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" (ngModelChange)="
                    selectedStockPreset = null; selectedPreset = null
                  " />
                <span class="text-muted">to</span>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" (ngModelChange)="
                    selectedStockPreset = null; selectedPreset = null
                  " />
              </div>
              <small class="text-muted mt-2 d-block">
                Manual date selection overrides any preset choice.
              </small>
            </div>
          </div>

          <div class="modal-footer bg-white border-top shadow-sm">
            <!-- Progress feedback: large exports spend most of their time on
                 the server with no bytes flowing, so an indeterminate bar is
                 shown until a real percentage is available. -->
            <div *ngIf="isLoading" class="w-100 mb-2">
              <div class="progress" style="height: 6px">
                <div class="progress-bar"
                  [class.progress-bar-striped]="downloadProgress === 0"
                  [class.progress-bar-animated]="downloadProgress === 0"
                  role="progressbar"
                  [style.width.%]="downloadProgress > 0 ? downloadProgress : 100">
                </div>
              </div>
              <small class="text-muted">
                {{ downloadLabel }}
                <span *ngIf="downloadedBytes > 0">
                  &middot; {{ formatBytes(downloadedBytes) }}</span>
              </small>
            </div>
            <button class="btn btn-secondary" (click)="closeReportModal()">
              Cancel
            </button>
            <button class="btn btn-success" (click)="downloadReport()" [disabled]="isLoading || !hasValidSelection">
              <i *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></i>
              {{ downloadLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>